import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {Helper} from '../../utils/helper.module';
import {Order} from "./order";

import { WINDOW, LOCAL_STORAGE } from '@ng-toolkit/universal';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class BooKingservice {

  iSId3Confirm:boolean = false;
  constructor(
    @Inject(WINDOW) private window:Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient) {

  }

  removeItem(key):Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      try{
        localStorage.removeItem(key);
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }


  store(key,value):Promise<any>{
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }

  retrieve(key) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let value = localStorage.getItem(key);
        return JSON.parse(value);
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }


  clearStorage() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.clear();
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }


  saveOrder(order:Order):Promise<any> {
    return this.http.post(Helper.api('order/create'), order)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  confirm(pay:any):Promise<any> {
    return this.http.post(Helper.api('sucessPayment'), pay)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  confirmDeadline(pay:any):Promise<any> {
    return this.http.post(Helper.api('sucessPaymentDeadline'), pay)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  addPasswordToPreaccount(pass):Promise<any> {
    return this.http.post(Helper.api('addpasswordtopreaccount'), pass)
      .toPromise()
      .then((response) => {
        console.log(response);
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  clearAndInitBookingItemInStorage() {
    this.store('isNormalPayment',true);
  }

  // TODO: #MEDIUM repeated code
  // with ctach() use an arrow function in order to use the keyword this
  private handleError(error: any, redirectUrl?: string): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error.json());
  }

}
